/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { configuredClustersStore } from 'stores';

import { replaceGrpcUrlWithHttp } from './replace-grpc-url-with-http';

export default function getPlayAuthConfig(playClusterId) {
  const clusterInfo = configuredClustersStore?.clusters?.find((cluster) => cluster.id === playClusterId);
  const { isClientCredentialsPresent, clientCredentials } = getClientCredentials();

  return {
    type: 'sm',
    config: {
      clusterId: clusterInfo?.id,
      zeebeAddress: replaceGrpcUrlWithHttp(clusterInfo?.urls?.zeebeGrpc),
      zeebeRestUrl: clusterInfo?.urls?.zeebeRest,
      tasklistBaseUrl: clusterInfo?.urls?.tasklist,
      operateBaseUrl: clusterInfo?.urls?.operate,
      tenantId: localStorage.getItem('playTenantId') || '<default>',
      ...(isClientCredentialsPresent ? { credentials: clientCredentials } : {}),
      ...(clusterInfo?.oauth ? { oauth: clusterInfo.oauth } : {}),
      authentication: clusterInfo?.authentication
    }
  };
}

const getClientCredentials = () => {
  const clientId = localStorage.getItem('playClientId');
  const clientSecret = localStorage.getItem('playClientSecret');
  const clientCredentials = { id: clientId, secret: clientSecret };
  return { isClientCredentialsPresent: clientId && clientSecret, clientCredentials };
};
